import script from "./MenuSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuSearch.vue?vue&type=script&setup=true&lang=ts"

import "./MenuSearch.vue?vue&type=style&index=0&id=53e44994&scoped=true&lang=less"
import "./MenuSearch.vue?vue&type=style&index=1&id=53e44994&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e44994"]])

export default __exports__